import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Welcome from "@/pages/Welcome";
import PackagesComparison from "@/pages/PackagesComparison";
import PackageIntro from "@/pages/package-flow/PackageIntro";
import PersonalDetails from "@/pages/package-flow/PersonalDetails";
import PowerOfAttorney from "@/pages/package-flow/PowerOfAttorney";
import POPIConsent from "@/pages/package-flow/POPIConsent";
import PricingPage from "@/pages/package-flow/PricingPage";
import AddOns from "@/pages/package-flow/AddOns";
import EngagementLetter from "@/pages/package-flow/EngagementLetter";
import PaymentMethod from "@/pages/package-flow/PaymentMethod";
import DebitOrderMandate from "@/pages/package-flow/DebitOrderMandate";
import { PackageProvider } from "@/context/PackageContext";

function App() {
  return (
    <div className="min-h-screen bg-background">
      <BrowserRouter>
        <PackageProvider>
          <Routes>
            {/* Main site */}
            <Route path="/" element={<Welcome />} />
            <Route path="/page-1" element={<Welcome />} />
            <Route path="/page-2" element={<PackagesComparison />} />

            {/* Package flows — static routes must come before /:packageSlug */}
            <Route path="/:packageSlug" element={<PackageIntro />} />
            <Route path="/:packageSlug/details" element={<PersonalDetails />} />
            <Route path="/:packageSlug/poa" element={<PowerOfAttorney />} />
            <Route path="/:packageSlug/popi" element={<POPIConsent />} />
            <Route path="/:packageSlug/pricing" element={<PricingPage />} />
            <Route path="/:packageSlug/add-ons" element={<AddOns />} />
            <Route path="/:packageSlug/engagement" element={<EngagementLetter />} />
            <Route path="/:packageSlug/payment" element={<PaymentMethod />} />
            <Route path="/:packageSlug/debit-order" element={<DebitOrderMandate />} />

            {/* Catch-all */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </PackageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
